<template>
  <div class="prevent-user-selection">
    <StorageListResultsInfo
      :isShowSearchingInfo="isShowSearchingInfo"
      :handleSearchingInfoShow="handleSearchingInfoShow"
      :handleFileNameChange="handleFileNameChange"
      :handleSelectedTagsChange="handleSelectedTagsChange"
    />
    <div
      :class="[
        'storage-results',
        isStorageContentLoading ? 'd-flex justify-center align-center' : ''
      ]"
    >
      <v-progress-circular
        v-if="isStorageContentLoading"
        indeterminate
        color="primary"
      ></v-progress-circular>

      <ul v-else class="storage-list">
        <li
          :class="[
            'storage-list__item',
            `storage-list-item-${storageItem.id}`,
            renderStorageItemActiveClassName(storageItem.id)
          ]"
          v-for="storageItem in storageContent.storageItems"
          :key="storageItem.id"
          role="button"
          @click.stop="handleStorageItemClick($event, storageItem)"
          @dblclick="handleStorageItemClick($event, storageItem)"
        >
          <div class="storage-list__item-icon-wrapper">
            <v-checkbox
              v-if="!storageItem.virtual && $route.params.orgId"
              class="storage-item-multi-select-checkbox"
              @change="handleStorageItemMultiSelect(storageItem, $event)"
            />
            <StorageItemContextMenu :storageItem="storageItem" />
            <div
              class="storage-list__item-icon-wrapper--directory"
              v-if="storageItem.type === DIRECTORY"
            >
              <span class="storage-list__sub-items-count">{{
                storageItem.subItemsCount
              }}</span>
              <img src="../../../assets/icons/folder.png" alt="Folder icon" />
            </div>

            <div
              v-else-if="storageItem.type === FORM"
              class="storage-list__item-icon-wrapper--directory"
            >
              <img src="../../../assets/icons/form.png" alt="Form icon" />
            </div>

            <div
              v-else-if="storageItem.type === TODO"
              class="storage-list__item-icon-wrapper--directory"
            >
              <img src="../../../assets/icons/todo.png" alt="Todo icon" />
            </div>
            <v-icon v-else-if="storageItem.type === LINK" size="60" color="#000"
              >mdi-link</v-icon
            >
            <img
              v-else-if="isRenderFileIcon(storageItem)"
              src="../../../assets/icons/file.png"
              alt="File icon"
            />
            <div v-else class="storage-list-item__thumbnail-wrapper">
              <img
                class="thumbnail"
                :src="isRenderFileThumbnail(storageItem)"
                alt="Thumbnail"
              />
              <v-icon
                v-if="isRenderVideoIcon(storageItem)"
                size="40"
                color="white"
                class="storage-list-item__video-icon"
                >mdi-play-circle-outline
              </v-icon>
            </div>
          </div>
          <span class="storage-list__item-label">{{
            substringStorageItemName(storageItem.name, 30)
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { StorageItemTypes } from "@/views/academy/enums/StorageItemTypes";
import { MediaFileTypes } from "../enums/MediaFileTypes";
import { ModuleTypes } from "@/store/ModuleTypes";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { MediaFileTypesDocIconArr } from "@/views/academy/enums/MediaFileTypesDocIconArr";
import { substringStorageItemName } from "@/helpers/substringStorageItemName";
import StorageItemContextMenu from "@/views/academy/storage/files/StorageItemContextMenu";
import { ContentTypes } from "@/views/academy/enums/ContentTypes";
import StorageListResultsInfo from "@/views/academy/storage/StorageListResultsInfo";

export default {
  name: "StorageList",
  components: { StorageListResultsInfo, StorageItemContextMenu },
  data: () => ({
    DIRECTORY: StorageItemTypes.DIRECTORY,
    FORM: StorageItemTypes.FORM,
    TODO: StorageItemTypes.TODO,
    DOC: MediaFileTypes.DOC,
    LINK: StorageItemTypes.LINK,
    MediaFileTypesDocIconArr: MediaFileTypesDocIconArr,
    substringStorageItemName,
    clickCounter: 0
  }),
  props: {
    setIsShowAdminFoldersRootLevel: {
      type: Function,
      required: true
    },
    handleSearchingInfoShow: {
      type: Function,
      required: true
    },
    handleFileNameChange: {
      type: Function,
      required: true
    },
    handleSelectedTagsChange: {
      type: Function,
      required: true
    },
    isShowSearchingInfo: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters(ModuleTypes.STORAGE, [
      "storageContent",
      "storageItemDetails",
      "lastAddedStorageItemId",
      "isStorageContentLoading",
      "storageSearchInputValue",
      "multiSelectItems",
      "isMultiSelect"
    ])
  },

  methods: {
    ...mapMutations(ModuleTypes.STORAGE, [
      "setLastAddedStorageItemId",
      "setStorageSearchInputValue",
      "setStorageSearchInputFocused",
      "toggleStorageLinkModal",
      "setIsMultiSelect",
      "setMultiSelectItems",
      "clearStorageItemDetails",
      "clearMultiSelect"
    ]),

    ...mapActions(ModuleTypes.STORAGE, [
      "setStorageItemDetails",
      "fetchStorageContent",
      "hideStorageItemDetails",
      "addRecentStorageItemInPlayerContext"
    ]),

    ...mapMutations(ModuleTypes.STORAGE_ITEM_DETAILS, [
      "toggleStorageItemPreviewDialog"
    ]),

    ...mapActions(ModuleTypes.STORAGE_ITEM_DETAILS, [
      "fetchStorageItemPresignedUrl"
    ]),

    handleStorageItemDetailsPreviewDialog(storageItemDetails) {
      this.fetchStorageItemPresignedUrl({ storageItemDetails });
      this.toggleStorageItemPreviewDialog({
        isPreviewDialogOpened: true
      });
    },

    handleStorageItemClick(e, storageItem) {
      this.setLastAddedStorageItemId("");
      this.clickCounter++;
      if (this.clickCounter === 1) {
        setTimeout(() => {
          if (this.clickCounter === 1 && !storageItem?.virtual) {
            this.setStorageItemDetails({ storageItem });
            if (this.$route.params?.playerId) {
              this.addRecentStorageItemInPlayerContext({
                organizationId: this.$route.params?.organizationId,
                playerId: this.$route.params?.playerId,
                storageItemId: storageItem?.id
              });
            }
          } else if (this.clickCounter >= 2) {
            this.clearMultiSelect();
            if (storageItem.type === StorageItemTypes.DIRECTORY) {
              this.setStorageSearchInputValue("");
              this.setStorageSearchInputFocused(false);
              this.hideStorageItemDetails();
              if (!storageItem?.sharedWithMe) {
                if (this.$route.params.playerId) {
                  this.$router.push(
                    `/academy/storage/organization/${this.$route.params.organizationId}/player/${this.$route.params.playerId}/${storageItem?.id}`
                  );
                }
                if (this.$route.params.teamId) {
                  this.$router.push(
                    `/academy/storage/${this.$route.params.orgId}/${this.$route.params.teamId}/organization/${storageItem?.id}`
                  );
                } else if (this.$route.params.orgId) {
                  this.$router.push(
                    `/academy/storage/${this.$route.params.orgId}/organization/${storageItem?.id}`
                  );
                }
              }
              this.fetchStorageContent({
                organizationId:
                  this.$route.params?.orgId ||
                  this.$route.params?.organizationId,
                parentId: storageItem?.id,
                playerId: this.$route?.params?.playerId || null,
                storageItemId: storageItem?.id,
                accessType: storageItem?.accessType,
                sharedWithMe: storageItem?.sharedWithMe
              });
              this.setIsShowAdminFoldersRootLevel(false);
            } else if (
              storageItem?.fileMetadata?.contentType?.includes(
                ContentTypes.IMAGE
              ) ||
              storageItem?.fileMetadata?.contentType?.includes(
                ContentTypes.VIDEO
              )
            ) {
              this.setStorageItemDetails({ storageItem, isContextMenu: true });
              this.handleStorageItemDetailsPreviewDialog(storageItem);
            } else if (
              storageItem?.fileMetadata?.contentType?.includes(ContentTypes.PDF)
            ) {
              this.setStorageItemDetails({ storageItem, isContextMenu: true });
              this.fetchStorageItemPresignedUrl({
                storageItemDetails: storageItem,
                callback: res => {
                  if (res) {
                    window.open(res);
                  }
                }
              });
            } else if (storageItem.type === StorageItemTypes.LINK) {
              this.setStorageItemDetails({ storageItem, isContextMenu: true });
              this.toggleStorageLinkModal({ linkModalOpen: true });
            }
          }
          this.clickCounter = 0;
        }, 300);
      }
    },
    handleStorageItemMultiSelect(item, isSelected) {
      if (isSelected) {
        this.setMultiSelectItems({
          multiSelectItems: [...this.multiSelectItems, item]
        });
      } else {
        const multiSelectItems = this.multiSelectItems.filter(
          i => i.id !== item.id
        );
        this.setMultiSelectItems({ multiSelectItems });
      }
    },
    renderStorageItemActiveClassName(storageItemId) {
      if (
        storageItemId === this.storageItemDetails?.id ||
        storageItemId === this.lastAddedStorageItemId ||
        (this.isMultiSelect &&
          this.multiSelectItems.find(i => i.id === storageItemId))
      ) {
        return "storage-list__item--active";
      } else {
        return "";
      }
    },
    isRenderFileIcon(storageItem) {
      return MediaFileTypesDocIconArr.includes(
        storageItem?.fileMetadata?.fileType
      );
    },
    isRenderFileThumbnail(storageItem) {
      return storageItem?.fileMetadata?.thumbnailPresignedUrl;
    },

    isRenderVideoIcon(storageItem) {
      return storageItem?.fileMetadata?.fileType === MediaFileTypes.VIDEO;
    }
  },
  watch: {
    "multiSelectItems.length"(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal <= 1) {
          this.setIsMultiSelect({ isMultiSelect: false });
        } else {
          this.setIsMultiSelect({ isMultiSelect: true });
        }
      }
    }
  }
};
</script>

<style scoped>
.storage-results {
  position: absolute;
  top: 150px;
  left: 0;
  height: calc(100vh - var(--top-nav-desktop-height) - 180px);
  width: 100%;
}

.prevent-user-selection {
  i-webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

@media (max-width: 959px) {
  .storage-results {
    height: calc(100vh - var(--top-nav-mobile-height) - 180px);
  }
}

.storage-list {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  height: 100%;
  width: 100%;
  overflow-y: auto;
}

@media (max-width: 452px) {
  .storage-list {
    height: 95%;
  }
}

.storage-list__item {
  position: relative;
  width: 160px;
  height: 180px;
  margin: 0 10px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  text-align: center;
  font-weight: var(--font-weight-medium);
  color: var(--dark-color);
}

.storage-list__item:hover .storage-list__item-icon-wrapper,
.storage-list__item--active .storage-list__item-icon-wrapper {
  background-color: var(--primary-color--dark);
}

.storage-list__item-label {
  height: 40px;
  word-break: break-all;
}

.storage-list__item:hover .storage-list__item-label,
.storage-list__item--active .storage-list__item-label {
  color: var(--primary-color);
}

.storage-list__item-icon-wrapper {
  width: 100%;
  max-height: 130px;
  flex-grow: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
  border-radius: 10px;
}

.thumbnail {
  max-width: 90%;
  max-height: 90%;
  padding: 16px;
}

.storage-list__item-icon-wrapper--directory {
  position: relative;
}

.storage-list__sub-items-count {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1rem;
}

.storage-list-item__thumbnail-wrapper {
  position: relative;
  width: 90%;
  height: 90%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.storage-list-item__video-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.storage-item-multi-select-checkbox {
  display: none !important;
}
.storage-list__item:hover
  .storage-list__item-icon-wrapper
  .storage-item-multi-select-checkbox {
  display: inline !important;
  position: absolute;
  top: -9%;
  left: 2%;
  overflow: hidden;
  z-index: 5;
}
.storage-list__item--active .storage-item-multi-select-checkbox {
  display: inline !important;
  position: absolute;
  top: -9%;
  left: 2%;
  overflow: hidden;
}
</style>
